import React from "react";

import { Link as RouterLink } from "react-router-dom";

import { Link, Button, Avatar, Typography, Card, Box } from "@mui/material";
import { PersonAdd } from "@mui/icons-material";
import { teal } from "@mui/material/colors";
import Footer from "../parts/Footer";

import { MultilineLabel } from "../parts/TabPanel";
import Define from "../../configurations/Define";

const ToSignUp = () => {
    return (
        <Box display="flex" flexDirection="column" sx={{height: "100%"}}>
            <Box pl="1rem" pr="1rem">
                <Link href={Define.copyright.baseTop} underline="none" color="#333333" style={{textDecoration: "none", display: "inline-flex", justifyContent: "flex-start", alignItems: "center"}}>
                    <img src="/hp.png" style={{width: "40px", height: "40px"}} alt="アイコン" />
                    <span style={{fontFamily: "Noto Serif JP, serif", fontSize: "48px", marginLeft: ".5rem"}}>{"meuxia"}</span>
                </Link>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{flex: "auto"}}>
                <Box sx={{overflow: "auto"}}>
                    <Card sx={{display: "inline-block", m: 2, p: 2, width: 320}}>
                        <Box component="div" pl={1} sx={theme => ({backgroundColor: theme.palette.primary.main, width: 1})}>
                            <Typography variant="h6" pl={1} sx={theme => ({backgroundColor: theme.palette.background.default})}>初めてご利用の方</Typography>
                        </Box>
                        <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" m={2}>
                            <Avatar sx={{ bgcolor: teal[400] }}><PersonAdd /></Avatar>
                            <Typography variant={"h5"} sx={{ ml: 1 }}>無料会員登録</Typography>
                        </Box>
                        <Box sx={{height: 300}} display="flex" flexDirection="column">
                            <MultilineLabel sx={{flex: "auto"}} text={"ご利用には無料会員登録が必要です。\nはじめてご利用の方お客様は、こちらから無料会員登録を行ってください。"}/>
                            <Link component={RouterLink} to="/signup" sx={{width: "100%"}}>
                                <Button type="button" variant="contained" color="primary" sx={{width: "100%"}}>無料会員登録</Button>
                            </Link>
                        </Box>
                    </Card>
                </Box>
            </Box>
            <Footer />
        </Box>
    );
};
export default ToSignUp;

